import "./style/applications.scss";

import { getUIToRender } from "./helperFunctions/getUIToRender";
import BrowserInfo from "./hooks/BrowserInfo/BrowserInfo";
import { brand } from "./brandVariables/getBandVariables";
import { useClientData } from "./hooks/useClientData";
import backgroundVideo from "./assets/jbl bg.webm";
import { PreviewMode } from "./pages/PreviewMode";

function App() {
  const { clientData } = useClientData(brand.client, false);
  document.title = `${brand.brand} - leaderboard`;

  if (window.location.pathname.includes("test")) {
    return <BrowserInfo />;
  }

  if (window.location.pathname.includes("preview")) {
    return <PreviewMode />;
  }

  return (
    <div className={`App ${brand.gameStyle} theme-${brand.brand}`}>
      {brand.client === "JBL" && (
        <video
          autoPlay
          muted
          loop
          id="background-video"
          src={backgroundVideo}
        />
      )}

      <body className="landing-bg">{getUIToRender({ clientData })}</body>
    </div>
  );
}

export default App;
